import {Component, OnInit} from '@angular/core';
import {LoaderService} from '../../shared/services/loader.service';
import {ToastrService} from 'ngx-toastr';
import {UserService} from '../shared/user.service';
import {HttpErrorResponse} from '@angular/common/http';
import {ActivatedRoute, Params} from '@angular/router';
import {CarrierManagerService} from '../shared/carrier-manager.service';
import {CarrierService} from '../shared/carrier.service';
import {Carrier} from '../shared/carrier.model';
import {NavigationService} from '../../shared/services/navigation.service';
import {finalize} from 'rxjs/operators';
import {ModalService} from '../../shared/services/modal.service';
import {BluechatService} from '../../bluechat/bluechat.service';
import {BluechatUserCreation} from '../../bluechat/models/BluechatUserCreation';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {UserInfoWithNames} from '../user-table/user-table.component';
import {FEATURES, FeatureService} from '../../shared/services/feature.service';
import {UserSearchCriteria} from '../../shared/user-search-criteria';

@Component({
  selector: 'app-carrier-manager-list',
  templateUrl: './carrier-manager-list.component.html',
  styleUrls: ['./carrier-manager-list.component.scss']
})
export class CarrierManagerListComponent implements OnInit {

  refresh: BehaviorSubject<void>;

  carrierId: string;

  carriers: Carrier[];

  selectedCarrier: Carrier;

  bluechatEnabledOnCarrier: boolean;
  bluechatEnabled = false;

  bluechatMultiUserActivationSubject: Subject<void> = new Subject();

  filters = new UserSearchCriteria();

  currentUserIsCarrierManager: boolean;

  loadPage: (page: number, pageSize: number) => Observable<any>;

  activateBluechat = (userDetails: UserInfoWithNames) =>
    this.bluechatService.enableBluechatOnCarrierManager(userDetails.user.id, this.createBluechatUserCreationRequest(userDetails));

  constructor(private route: ActivatedRoute,
              private navigation: NavigationService,
              private userService: UserService,
              private carrierService: CarrierService,
              private carrierManagerService: CarrierManagerService,
              private loader: LoaderService,
              private toastr: ToastrService,
              private modalService: ModalService,
              private bluechatService: BluechatService,
              private featureService: FeatureService
  ) {
    this.route.params.subscribe((params: Params): void => {
      this.carrierId = params.carrierId;

      this.loader.startLoad(false);

      if (!this.carrierId) {
        carrierService.getSelfCarrier()
            .pipe(finalize(() => loader.stopLoad()))
            .subscribe(carrier => {
              this.currentUserIsCarrierManager = true;
              this.carrierId = carrier.id;
              this.carriers = [];
              this.selectedCarrier = carrier;
              this.bluechatEnabledOnCarrier = this.selectedCarrier.bluechatEnabled();
              this.loadPage = (page: number, pageSize: number) => this.carrierManagerService.searchByCarrier(this.carrierId, page, pageSize, this.filters);
            }, (error: HttpErrorResponse) => {
              console.log(error);
              this.toastr.error(error.error.message || 'Error while fetching the carrier and carrier managers', 'Error');
            });
      } else {
        carrierService.getAllLight()
            .pipe(finalize(() => loader.stopLoad()))
            .subscribe((carriers) => {
              this.carriers = carriers;
              this.selectedCarrier = carriers.find(c => c.id === this.carrierId);
              this.bluechatEnabledOnCarrier = this.selectedCarrier.bluechatEnabled();
              this.loadPage = (page: number, pageSize: number) => this.carrierManagerService.searchByCarrier(this.carrierId, page, pageSize, this.filters);
            }, (error: HttpErrorResponse) => {
              console.log(error);
              this.toastr.error(error.error.message || 'Error while fetching the carriers and carrier managers', 'Error');
            });
      }

    });
  }

  ngOnInit() {
    this.featureService.getFeatureStatusObservable(FEATURES.BLUECHAT).subscribe(bluechatStatus => this.bluechatEnabled = bluechatStatus);
  }

  goToManagers(carrierId: string): void {
    this.loadPage = (page: number, pageSize: number) =>
      this.carrierManagerService.searchByCarrier(carrierId, page, pageSize, this.filters);
    this.navigation.carriers()
      .managers(carrierId)
      .list()
      .go();
  }

  goToDrivers(carrierId: string): void {
    this.navigation.carriers()
      .drivers(carrierId)
      .list()
      .go();
  }

  goToCreateCarrierManager(carrierId: string): void {
    this.currentUserIsCarrierManager
        ? this.navigation.selfCarrier().carrierManager().create().go()
        : this.navigation.carriers().managers(carrierId).create().go();
  }

  goToEditCarrierManager(carrierId: string, managerId: string): void {
    this.currentUserIsCarrierManager
        ? this.navigation.selfCarrier()
            .carrierManager()
            .edit(managerId)
            .go()
        : this.navigation.carriers()
            .managers(carrierId)
            .edit(managerId)
            .go();
  }

  triggerBluechatActivationForSelectedUsers() {
    this.bluechatMultiUserActivationSubject.next();
  }

  private createBluechatUserCreationRequest(userInfo: UserInfoWithNames): BluechatUserCreation {
    return {
      bluechat_carrier_code: userInfo.user.carrier.bluechatCarrierCode,
      firstname: userInfo.firstname,
      lastname: userInfo.lastname,
      email: userInfo.user.email,
    };
  }
}
